import FormField from "../common/FormField";
import { sectionFieldsFor } from "../../services/core";

const humanize = (key) => key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());

export default function AssessmentSections({ allowed, map, labels = {}, form, setForm, readOnly }) {
  const fields = sectionFieldsFor(allowed, map);
  return (
    <div className="form-grid">
      {fields.map(({ apiKey, uiKey }) => {
        const meta = labels[uiKey] || {};
        return (
          <FormField key={uiKey} label={meta.label || humanize(apiKey)} required className="span-2" hint={meta.hint}>
            <textarea
              rows={3}
              value={form[uiKey] || ""}
              onChange={(e) => setForm((f) => ({ ...f, [uiKey]: e.target.value }))}
              disabled={readOnly}
              placeholder={meta.placeholder}
            />
          </FormField>
        );
      })}
    </div>
  );
}
